// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Element from 'element-ui'
import TWEEN from 'tween'
import 'babel-polyfill'
import App from './App'
import {
  router
} from './router'
import store from './store'
import filters from './filters'
import axios from 'axios'
import 'animate.css'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/diy.scss'
import '@/styles/base.css'
import '@/styles/transition.scss'

import './assets/iconfont/iconfont.css'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
Vue.prototype.$tween = TWEEN
Vue.use(Element)
Vue.config.productionTip = false
Vue.prototype.$axios = axios

axios.defaults.withCredentials = true
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]))
const originalPush = router.push
router.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
router.beforeEach((to, from, next) => {
  if (window._hmt) {
    if (to.path) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }
  const title = to.meta && to.meta.title
  if (title) {
    document.title = title
  }
  switch (to.path) {
    case '/overview':
      store.commit('setTabActive', 'tab1')
      break;
    case '/news':
      store.commit('setTabActive', 'tab2')
      break;
    case '/center':
      store.commit('setTabActive', 'tab3')
      break;
    case '/cloudTheater':
      store.commit('setTabActive', 'tab4')
      break;
    case '/education':
      store.commit('setTabActive', 'tab5')
      break;
    case '/goods':
      store.commit('setTabActive', 'tab6')
      break;
    case '/cooperation':
      store.commit('setTabActive', 'tab7')
      break;
    default:
      store.commit('setTabActive', '')
      break;
  }
  setTimeout(res => {
    console.log('先执行')
    // 判断该user是够需要登录权限
    if (to.meta.requireAuth) {
      // 通过vue sate获取当前状态值
      if (store.state.token) {
        next()
      } else {
        next({
          path: '/index',
        })
      }
    } else {
      next()
    }
  }, 100)

})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
})


// WEBPACK FOOTER //
// ./src/main.js